import { IUserDeclarationReducer } from 'interfaces/store/IStore';

export const initialUserDeclarationState: IUserDeclarationReducer = {
  listSorting: undefined
};
